import { HygraphWearable } from '@repo/types-client';

const globCostMap: { [key: string]: number } = {
  Essential: 60,
  Exclusive: 600,
  Grail: 3000,
  iconic: 60000,
};

/**
 * Retrieves the cost for a given tier.
 * @function getCostForTier
 * @param {string} tier - The tier of the wearable.
 * @returns {number} The cost associated with the tier.
 */
export const getCostForTier = (tier: string): number => {
  const wearableTierCost = globCostMap[tier];
  if (!wearableTierCost) {
    console.error(`Invalid tier: ${tier}`);
    return 0;
  }
  return wearableTierCost;
};

/**
 * Resolves the base cost for a wearable template.
 * @function resolveWearableTemplateBaseCost
 * @param {HygraphWearable} wearable - The wearable object.
 * @returns {number} The base cost of the wearable.
 */
const resolveWearableTemplateBaseCost = (wearable: HygraphWearable): number => {
  if (wearable.globCostOverride) {
    return wearable.globCostOverride;
  }

  return getCostForTier(wearable.tier as string);
};

/**
 * Calculates the total cost for a wearable.
 * @function calculateWearableCost
 * @param {HygraphWearable} wearable - The wearable object.
 * @returns {number} The total cost of the wearable.
 */
export const calculateWearableCost = (wearable: HygraphWearable): number => {
  return resolveWearableTemplateBaseCost(wearable);
};
